var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomElectricityLightOutdoor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 73,
    viewBox: "0 0 66 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "14.812%",
    y1: "64.529%",
    y2: "7.95%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0.75
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-gradient",
    fill: "url(#a)",
    d: "M19.998 82.592l-9.375-55.031 19.189-11.53L74 50.145z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M13 10v5H0v-5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M12.5 10.5H.5v4h12v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M19.952 9.705l.32-.002c4.451-.024 8.67 2.367 11.01 6.239l.13.215L10.02 29.09l-.13-.215c-2.356-3.897-2.5-8.767-.376-12.71l.152-.283L5.798 4.084c-.264-.807.659-1.89 1.692-2.606l.366-.254.396-.204C9.369.444 10.759.137 11.348.75l8.604 8.955z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M10.19 28.403l20.534-12.414c-2.274-3.598-6.256-5.809-10.45-5.786l-.534.003-.149-.155-8.603-8.955c-.327-.34-1.404-.2-2.508.369l-.339.17-.366.254c-1.02.707-1.648 1.593-1.501 2.04l3.932 12.001-.1.189-.153.282c-2 3.716-1.905 8.293.237 12.002z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomElectricityLightOutdoor);
export default __webpack_public_path__ + "static/media/RoomElectricityLightOutdoor.17114ca165b19ef13bbfd8449ff24b19.svg";
export { ForwardRef as ReactComponent };